import ForumIcon from "@mui/icons-material/Forum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookMessenger, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { ChannelTypeEnum } from "../../../common/enums/ChannelTypeEnum";

type ConversationAvatarProps = {
  channelType?: ChannelTypeEnum;
  name: string;
};

export function ConversationAvatar({ channelType, name }: ConversationAvatarProps) {
  if (channelType === ChannelTypeEnum.Facebook) {
    return (
      <FontAwesomeIcon
        icon={faFacebookMessenger}
        style={{ fontSize: "30px", color: "#0084FF" }} 
      />
    );
  }

  if (channelType === ChannelTypeEnum.Instagram) {
    return (
      <FontAwesomeIcon
        icon={faInstagram}
        style={{ fontSize: "30px", color: "#E4405F" }} 
      />
    );
  }

  return (
    <ForumIcon sx={{ fontSize: 30, color: "#0084FF" }} />
  );

  // If you still want InitialsAvatar fallback:
  // return (
  //   <InitialsAvatar
  //     name={formatAvatarString(name)}
  //     maxInitials={2}
  //     textSizeRatio={1.75}
  //     size="30"
  //     round
  //   />
  // );
}